import { MouseEvent } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

export enum SearchBreadcrumbPageNames {
  ContractsBC = 'Contracts',
  BillingBC = 'Billing',
  Billing = 'Billing (OLD)',
  Customers = 'Customers',
  VariableBilling = 'Variable Billing',
  Products = 'Products',
  UpliftsHistory = 'Uplifts History',
  BillingCycles = 'Billing Cycles',
  ClientDatabases = 'Client Databases',
  PurchaseOrders = 'Purchase Orders',
  ContractLines = 'Contract Lines',
  Bundles = 'Bundles',
}

interface IFilteredBySearchBreadcrumb {
  defaultText: string;
  breadcrumbPage: SearchBreadcrumbPageNames;
  path: string;
}

export default function GridFilteredBySearchBreadcrumb({
  defaultText,
  breadcrumbPage,
  path
}: IFilteredBySearchBreadcrumb) {
  const history = useHistory();
  const searchText = new URL(window.location.href).searchParams.get('search') ?? '';
  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;

    const isGridFilteredBySearchPage = matchPath(pathName, {
      path: path,
      exact: true
    });

    if (isGridFilteredBySearchPage) {
      window.location.reload();
    } else {
      const link = searchText ? `${path}?search=${encodeURIComponent(searchText)}` : path;
      history.push(getParameterizedLink(link));
    }
  };

  if (!searchText) {
    return (
      <a onClick={onClick} href={window.location.href}>
        {defaultText}
      </a>
    );
  }

  return (
    <a onClick={onClick} href={window.location.href}>
      {`${breadcrumbPage} searched by: ${searchText}`}
    </a>
  );
}
